import React from 'react';

// Catches render/lifecycle errors anywhere below it in the tree so a single
// broken page shows a recoverable screen instead of a blank white page
// (React unmounts the whole tree on an uncaught render error otherwise).
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error('Unhandled UI error caught by ErrorBoundary:', error, errorInfo);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="d-flex flex-column align-items-center justify-content-center text-center"
          style={{ minHeight: '100vh', padding: '2rem' }}
        >
          <h2>Something went wrong</h2>
          <p className="text-muted">
            An unexpected error occurred while rendering this page. Please try again.
          </p>
          {process.env.NODE_ENV === 'development' && this.state.error && (
            <pre
              className="text-start bg-light border rounded p-3 mt-2"
              style={{ maxWidth: '800px', overflow: 'auto', whiteSpace: 'pre-wrap' }}
            >
              {String(this.state.error.stack || this.state.error.message || this.state.error)}
            </pre>
          )}
          <button className="btn btn-primary mt-3" onClick={this.handleReload}>
            Reload
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
